module.exports = __webpack_public_path__ + "img/small_logo_with_label.10293298.svg";